<template>
  <v-col>
    <v-row justify="center">
      <v-row class="ma-2">
        <v-col cols="12" md="6">
          <v-row class="mb-2">
            <v-icon class="black-color" @click="$emit('close')">
              mdi-arrow-left
            </v-icon>
            <h4 class="grey-color mx-4" style="font-weight: 500">Document Info</h4>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" class="pa-0">
          <v-row justify="center" justify-md="end">
            <v-btn @click="$router.push('/home')" color="#e022d1" dark rounded width="240px" class="mb-8">
              Download
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <v-row justify="center">
      <div class="white-card">
        <v-col class="pa-8">
          <v-row justify="start">
            <h2 class="fs400 my-10">Document Info</h2>
          </v-row>
          <v-row justify="start">
            <v-col cols="6" md="3">
              <v-row>
                <p>First Name:</p>
              </v-row>
            </v-col>
            <v-col cols="6" md="3">
              <v-row>
                <p>Calvyn</p>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt-8" justify="start">
            <v-col cols="6" md="3">
              <v-row>
                <p>Order Number:</p>
              </v-row>
            </v-col>
            <v-col cols="6" md="3">
              <v-row>
                <p>92394</p>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt-8" justify="start">
            <v-col cols="6" md="3">
              <v-row>
                <p>Email Address:</p>
              </v-row>
            </v-col>
            <v-col cols="6" md="3">
              <v-row>
                <p>Calvyn610@gmail.com</p>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt-8" justify="start">
            <v-col cols="6" md="3">
              <v-row>
                <p>Certificate:</p>
              </v-row>
            </v-col>
            <v-col cols="6" md="3">
              <v-row>
                <p>Therapy</p>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </div>
    </v-row>
  </v-col>
</template>

<script>
export default {};
</script>

<style></style>